<template>
  <div>
    <a-card>
      <div v-if="contractFiling ">
        <span>贵单位在以下包组中成交，请扫描上传与采购人的合同进行备案</span>
        <span v-if="isPayVisible">，合同备案审查通过后予以退还投标保证金</span>
        <a-table ref="table" :columns="columns" :data-source="loadData" :rowKey="record => record.id"
                 :pagination="false" :loading="tableLoading">
          <template slot="operationSlot" slot-scope="text, record, index">
            <template v-if="record.showFlag">
            <div class="color-red">请将合同扫描为PDF格式文件上传</div>
            <div>
              <pre-case-upload-selector ref="UploadSelector" :referId='record.id'  configKey='CONTRACT.FILING'
                                        :readonly="record.state === '1'" @uploadSuccess="uploadSelectorChange"/>
            </div>
            </template>
            <template v-else>
              <p class="size2 mt-3 color-ash">通知书暂未发放，请耐心等待</p>
            </template>
          </template>
        </a-table>
        <br>
        <span style="color: red;font-size: 14px;">注：如多个包组合并签署一份合同，也请按包组分别上传备查，谢谢合作！</span>
      </div>
      <div v-else class="text-center" style="margin: 40px 0">
        <img style="margin: auto;width: 90px" src="../../img/empty4.png">
        <p class="size2 mt-3 color-ash" v-if="!contractFiling">暂无数据</p>
      </div>
    </a-card>
  </div>
</template>

<script>
import PreCaseUploadSelector from './PreCaseUploadSelector'
import qs from 'qs'

const uuidv4 = require('uuid/v4')
export default {
  components: {
    PreCaseUploadSelector
  },
  props: {
    projectId: {
      type: String,
      required: true
    },
    random: {
      type: String,
      default: '',
      required: false
    }
  },
  created() {
    this.loadTableData();
  },
  watch: {
    random: {
      immediate: false,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadTableData();
        }
      }
    }
  },
  name: "PreCase",
  data() {
    return {
      resultAnnounce: false,//有发布结果公告
      contractFiling: false,//有生成合同备案
      isPayVisible: false,//是否有保证金
      tableLoading: false,
      projectName: '',
      columns: [
        {
          title: '包组编号',
          dataIndex: 'bzxh',
        },
        {
          title: '包组名称',
          dataIndex: 'bzmc'
        },
        {
          title: '合同上传',
          width: '50%',
          scopedSlots: {customRender: 'operationSlot'}
        }
      ],
      loadData: [],
    }
  },
  mounted() {
  },
  methods: {
    //加载table的数据
    loadTableData() {
      let that = this;
      this.tableLoading = true;
      this.loadData = [];
      this.isPayVisible = false;
      this.contractFiling = false;
      this.resultAnnounce = false;
      that.$http.get('/api/v1/supplier/LegalResult/getWinLegalSupHtBa.json?projectId=' + that.projectId).then(function (response) {
        that.tableLoading = false;
        if (response.code == 200) {
          if (response.result && response.result.length > 0) {
            that.projectName = response.result[0].projectName
            that.contractFiling = true;
            that.isPayVisible = !!(response.result.filter(item => item.jntbbzj === '1')[0])
            that.loadData = response.result;
          }
        }
      })
    },
    uploadSelectorChange(fileLength, id) {
      let that = this;
      if (fileLength) {
        const user = this.$ls.get('user');
        let projectName = this.projectName;
        if (projectName && user.supplierName) {
          let title = "项目消息";
          let content = user.supplierName + "已上传了" + projectName + "的合同，请注意查看。";
          this.$http.get('/api/v1/supplier/bid/send_msg_in_project.json?id=' + this.projectId + '&title=' + title + '&content=' + content).then(function (res) {

          })
        }
      } else {
        //如果删除了合同备案附件 则也一并清除备案信息
        that.clearHtBaInfo(id)
      }
    },
    clearHtBaInfo(id) {
      this.$http.post('/api/v1/supplier/contract/filing/clear_bidContract_filing.json', qs.stringify({id: id})).then(function (res) {
        console.log("清除合同备案成功")
      })
    },
    editHtBaInfo(id) {
      this.$http.post('/api/v1/supplier/contract/filing/update_contract_filing.json', qs.stringify(id)).then(function (res) {
        console.log("更新合同备案成功")
      })
    }
  }
}
</script>

<style scoped>

</style>
